import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const nl = (n) => (Number(n) || 0).toLocaleString("nl-NL", { maximumFractionDigits: 1 });

// Dagverslag PDF voor de uitsnijderij. Let op: nooit fontStyle "italic" gebruiken (breekt tekst in jsPDF).
export function printDagVerslag({ jaar, week, datum, catRows = [], totaal = 0, filetRows = [], afvalRows = [] }) {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const M = 14;
  let y = 16;
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("Clazing Rosmalen — Uitsnijderij", M, y);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  y += 6;
  doc.text(`Dagverslag ${datum}   ·   week ${week} · ${jaar}`, M, y);

  autoTable(doc, {
    startY: y + 4,
    head: [["Output categorie", "kg", "% van dag"]],
    body: catRows.map((r) => [r.naam, nl(r.kg), r.pct]),
    foot: [["Totaal output", nl(totaal), "100%"]],
    styles: { fontSize: 9, cellPadding: 1.8 },
    headStyles: { fillColor: [28, 100, 176], textColor: 255 },
    footStyles: { fillColor: [241, 245, 249], textColor: 20, fontStyle: "bold" },
    columnStyles: { 1: { halign: "right" }, 2: { halign: "right" } },
    margin: { left: M, right: M },
  });
  y = doc.lastAutoTable.finalY + 8;

  if (filetRows.length) {
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("Filet-uitsplitsing", M, y);
    autoTable(doc, {
      startY: y + 2,
      head: [["Filet-soort", "kg", "type"]],
      body: filetRows.map((r) => [r.naam, nl(r.kg), r.bfilet ? "B-filet" : "A-filet"]),
      styles: { fontSize: 9, cellPadding: 1.8 },
      headStyles: { fillColor: [28, 100, 176], textColor: 255 },
      columnStyles: { 1: { halign: "right" }, 2: { halign: "center" } },
      margin: { left: M, right: M },
    });
    y = doc.lastAutoTable.finalY + 8;
  }

  if (afvalRows.length) {
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("Afval (Cat. 2/3)", M, y);
    autoTable(doc, {
      startY: y + 2,
      head: [["Afvalstroom", "kg"]],
      body: afvalRows.map((r) => [r.naam, nl(r.kg)]),
      styles: { fontSize: 9, cellPadding: 1.8 },
      headStyles: { fillColor: [217, 119, 6], textColor: 255 },
      columnStyles: { 1: { halign: "right" } },
      margin: { left: M, right: M },
    });
  }

  doc.save(`Dagverslag_Rosmalen_${datum}.pdf`);
}

// Weekverslag PDF: KPI's + output per categorie (% van verwerkte kappen) + vocht.
export function printWeekVerslag({ jaar, week, ingekocht = 0, verwerkt = 0, vocht = 0, filetTotaal = 0, bfilet = 0, totOutput = 0, catRows = [] }) {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const M = 14;
  let y = 16;
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("Clazing Rosmalen — Uitsnijderij", M, y);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  y += 6;
  doc.text(`Weekverslag week ${week} · ${jaar}`, M, y);
  y += 4;

  autoTable(doc, {
    startY: y + 2,
    body: [
      ["Kappen ingekocht", nl(ingekocht) + " kg"],
      ["Kappen verwerkt", nl(verwerkt) + " kg"],
      ["Totaal output", nl(totOutput) + " kg"],
      ["Filet-rendement", verwerkt > 0 ? (filetTotaal / verwerkt * 100).toFixed(1) + " %" : "—"],
      ["B-filet aandeel", filetTotaal > 0 ? (bfilet / filetTotaal * 100).toFixed(1) + " % v/d filet" : "—"],
      ["Vocht / snijverlies", nl(vocht) + " kg" + (verwerkt > 0 ? " (" + (vocht / verwerkt * 100).toFixed(1) + " %)" : "")],
    ],
    theme: "plain",
    styles: { fontSize: 9, cellPadding: 1.4 },
    columnStyles: { 0: { fontStyle: "bold", cellWidth: 60 }, 1: { halign: "right" } },
    margin: { left: M, right: M },
  });
  y = doc.lastAutoTable.finalY + 6;

  const body = catRows.map((r) => [r.naam, nl(r.kg), r.pct]);
  body.push(["Vocht / snijverlies", nl(vocht), verwerkt > 0 ? (vocht / verwerkt * 100).toFixed(1) + "%" : "—"]);
  autoTable(doc, {
    startY: y,
    head: [["Output categorie", "kg", "% van verwerkte kappen"]],
    body,
    foot: [["Verwerkte kappen (100%)", nl(verwerkt), "100%"]],
    styles: { fontSize: 9, cellPadding: 1.8 },
    headStyles: { fillColor: [28, 100, 176], textColor: 255 },
    footStyles: { fillColor: [241, 245, 249], textColor: 20, fontStyle: "bold" },
    columnStyles: { 1: { halign: "right" }, 2: { halign: "right" } },
    margin: { left: M, right: M },
  });
  doc.save(`Weekverslag_Rosmalen_wk${week}_${jaar}.pdf`);
}
